import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPalette } from '@fortawesome/free-solid-svg-icons';
import { IconButton } from '@material-ui/core';

import { Style } from './PenColorButton.css'

const PenColorButton = ({ onSelectColor }) => {
  const [isPenColorOpen, setIsPenColorOpen] = useState(false);
  const [currentColor, setCurrentColor] = useState('black');
  const penColorRef = useRef(null); // Reference to the pen color div

//   const colorOptions = [
//     { label: 'black', value: '#000000' },
//     { label: 'blue', value: '#0892e7' },
//     { label: 'orange', value: 'orange' },
//     { label: 'yellow', value: '#ebd808' },
//     { label: 'green', value: '#03a203' },
//     { label: 'red', value: '#e12929' },
//     { label: 'white', value: '#ffffff' },
//   ];

  const colorOptions = {
    'black': '#000000',
    'orange': '#f5ac0d', 
    'blue': '#0892e7', 
    'yellow': '#ebd808',
    'green': '#03a203',
    'red': '#e12929',
    'white': '#ffffff'
    }

  const handleColorSelect = (color, event) => {
    setCurrentColor(color);
    onSelectColor(colorOptions[color]); 
    setIsPenColorOpen(false);
    event.stopPropagation();
  };

  // Close the pen-width if clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      /* Check if the reference is not null && doesn't contain the click */
      if (penColorRef.current && !penColorRef.current.contains(event.target)) {
        setIsPenColorOpen(false);
      }
    };
    
    // Add event listener to detect clicks outside
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [penColorRef]);

return (
    <div className="pen-color-button">
      <IconButton onClick={() => setIsPenColorOpen(!isPenColorOpen)} title="Color">
        <FontAwesomeIcon icon={faPalette} />
      </IconButton>

      {isPenColorOpen && (
        <div className="pen-color-button__dropdown" ref={penColorRef}>
          <div className="pen-color-button__label">Color</div>
          <div className="pen-color-button__colors">
            <div
              className={`pen-color-button__color pen-color-button__color--black ${currentColor === 'black' ? 'active' : ''}`}
              onClick={(e) => handleColorSelect('black', e)}
              title="Black"
            ></div>
            <div
              className={`pen-color-button__color pen-color-button__color--orange ${currentColor === 'orange' ? 'active' : ''}`}
              onClick={(e) => handleColorSelect('orange', e)}
              title="Orange"
            ></div>
            <div
              className={`pen-color-button__color pen-color-button__color--blue ${currentColor === 'blue' ? 'active' : ''}`}
              onClick={(e) => handleColorSelect('blue', e)}
              title="Blue"
            ></div>
            <div
              className={`pen-color-button__color pen-color-button__color--yellow ${currentColor === 'yellow' ? 'active' : ''}`}
              onClick={(e) => handleColorSelect('yellow', e)}
              title="Yellow"
            ></div>
            <div
              className={`pen-color-button__color pen-color-button__color--green ${currentColor === 'green' ? 'active' : ''}`}
              onClick={(e) => handleColorSelect('green', e)}
              title="Green"
            ></div>
            <div
              className={`pen-color-button__color pen-color-button__color--red ${currentColor === 'red' ? 'active' : ''}`}
              onClick={(e) => handleColorSelect('red', e)}
              title="Red"
            ></div>
            <div
              className={`pen-color-button__color pen-color-button__color--white ${currentColor === 'white' ? 'active' : ''}`}
              onClick={(e) => handleColorSelect('white', e)}
              title="White"
            ></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PenColorButton;
